import React, { useEffect } from "react";
import { Route,Routes,useLocation, useSearchParams } from "react-router-dom";


export default function Navigation({routes}){
    const [searchParams] = useSearchParams();
    const lang = searchParams.get("lang");
    const location = useLocation();
    const activeRoute = (routeName) => {
        return location.pathname.indexOf(routeName) > -1 ? "active" : "";
      };

      useEffect(() => {
       
    if(!lang){
      localStorage.setItem('lang','en_US')
    }else localStorage.setItem('lang',lang)
      }, [])
      

    return(
        <Routes>
        {
            routes.map((prop, key)=> {
                return <Route path={prop.path} element={prop.component} key={key} exact />   
            })
        }
        </Routes>
    )
}